import emailAddressBookActions from "./actiontypes";
import config from "../../../config/config";

const {
  REQUEST_EMAIL_ADDRESS_BOOK,
  RECEIVE_EMAIL_ADDRESS_BOOK,
  REQUEST_GROUPS,
  RECEIVE_GROUPS,
  SERVER_ERROR_OCURED,
  CLEAR_ERRORS,
  GROUP_SERVER_ERROR_OCURED,
  GROUP_CLEAR_ERRORS,
  SEARCH_KEYWORD,
  SORT_ADDRESS_BOOK
} = emailAddressBookActions;

function hasError(errors) {
  return {
    type: SERVER_ERROR_OCURED,
    errors
  };
}

function hasGroupsError(errors) {
  return {
    type: GROUP_SERVER_ERROR_OCURED,
    errors
  }
}

export function getEmailAddressBook(token) {
  return fetch(`${config.URI}/api/v1/address_book`, {
    headers: {
      'Authenticity-Token': token,
      'Content-Type': 'application/json'
    }
  }).then(res => {
    if (!res.ok) {
      throw Error(res.statusText);
    } else {
      return res.json();
    }
  })
}

export function fetchEmailAddressBook(token) {
  console.log(token);
  // API Call goes here
  return function (dispatch) {
    dispatch({ type: REQUEST_EMAIL_ADDRESS_BOOK });
    getEmailAddressBook(token).then(res => {
      console.log("Res", res)
      if (res && res.status && res.status === 'success') {
        dispatch({ type: RECEIVE_EMAIL_ADDRESS_BOOK, emailAddressBook: res.data.address_book })
      } else if (res.errors) {
        console.log(res.errors);
      }
    }).catch(error => {
      dispatch(hasError(true));
      console.error(error);
    })
  }
}

export function getGroups(token) {
  return fetch(`${config.URI}/api/v1/groups`, {
    headers: {
      'Authenticity-Token': token,
      'Content-Type': 'application/json'
    }
  }).then(res => {
    if (!res.ok) {
      throw Error(res.statusText);
    } else {
      return res.json();
    }
  })
}

export function fetchGroups(token) {
  return function (dispatch) {
    dispatch({ type: REQUEST_GROUPS });
    getGroups(token).then(res => {
      if (res && res.status && res.status === 'success') {
        dispatch({ type: RECEIVE_GROUPS, groups: res.data.groups })
      } else if (res.errors) {
        console.log(res.errors);
      }
    }).catch(error => {
      dispatch(hasGroupsError(true));
      console.error(error);
    })
  }
}

export function clearGroupErrors() {
  return function (dispatch) {
    dispatch({ type: GROUP_CLEAR_ERRORS })
  }
}

export function clearErrors() {
  return function (dispatch) {
    dispatch({ type: CLEAR_ERRORS });
  }
}

export function searchKeyword(keyword) {
  return function (dispatch) {
    dispatch({ type: SEARCH_KEYWORD, keyword })
  }
}

export function sortAddressBook(by, sortType) {
  return function (dispatch) {
    dispatch({ type: SORT_ADDRESS_BOOK, by, sortType });
  }
}


// WEBPACK FOOTER //
// src/routes/EmailAddressBook/actions/index.js